import { z } from 'zod/v4'

export const updateCondolencesIntegrationSchema = z.object({
  enabled: z.boolean(),
  clear_token: z.boolean().optional(),
})

export const connectCondolencesLoginSchema = z.object({
  email: z.email('Enter the Condolences login email.').max(255),
  password: z.string().min(1, 'Enter the Condolences password.').max(255),
})
